import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const LocationsSection = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetch("https://api.npoint.io/bbc0df7568c4bde8594a");
        if (!response.ok) throw new Error("Failed to fetch");
        const data = await response.json();
        if (Array.isArray(data.locations)) {
          setLocations(data.locations);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, []);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <p>Loading Locations...</p>
      </div>
    );
  }

  const cardStyle = (index) => ({
    background: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
    border: `1px solid ${hoveredIndex === index ? "#c2d4f0" : "#f1f5f9"}`,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    transition:
      "transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.35s cubic-bezier(0.23, 1, 0.32, 1), border-color 0.35s ease",
    transform:
      hoveredIndex === index
        ? "translateY(-10px) scale(1.02)"
        : "translateY(0) scale(1)",
    boxShadow:
      hoveredIndex === index
        ? "0 24px 48px rgba(0, 44, 106, 0.13)"
        : "0 4px 20px -4px rgba(15, 23, 42, 0.05)",
    cursor: "pointer",
    height: "100%",
  });

  const imgStyle = (index) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)",
    transform: hoveredIndex === index ? "scale(1.06)" : "scale(1)",
  });

  const managerFooterStyle = (index) => ({
    marginTop: "auto",
    background: hoveredIndex === index ? "#eef3fb" : "#f8fafc",
    borderTop: "1px solid #f1f5f9",
    padding: "1.25rem 2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "background-color 0.3s ease",
    textDecoration: "none",
  });

  const arrowStyle = (index) => ({
    color: "#002c6a",
    fontSize: "1.1rem",
    opacity: hoveredIndex === index ? 1 : 0,
    transform: hoveredIndex === index ? "translateX(0)" : "translateX(-10px)",
    transition: "all 0.35s cubic-bezier(0.23, 1, 0.32, 1)",
  });

  return (
    <div className="container-fluid location py-5 mb-5 p-2">
      <div className="container">
        <div className="row g-4 justify-content-center">
          {locations.map((location, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 mb-4"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div style={cardStyle(index)}>

                {/* Top accent bar — slides in from left on hover */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "3px",
                    background: "linear-gradient(90deg, #002c6a, #1a5fb4)",
                    transform:
                      hoveredIndex === index ? "scaleX(1)" : "scaleX(0)",
                    transformOrigin: "left",
                    transition:
                      "transform 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
                    zIndex: 3,
                  }}
                />

                {/* Image & Floating Badge */}
                <div
                  style={{
                    height: "240px",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "16px",
                      right: "16px",
                      background: "rgba(255, 255, 255, 0.85)",
                      backdropFilter: "blur(8px)",
                      WebkitBackdropFilter: "blur(8px)",
                      padding: "6px 14px",
                      borderRadius: "20px",
                      fontSize: "0.8rem",
                      fontWeight: 700,
                      color: "#002c6a",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      zIndex: 2,
                    }}
                  >
                    <i className="fas fa-map-pin" style={{ color: "#002c6a" }}></i>
                    {location.city}
                  </div>
                  <img
                    src={location.image}
                    alt={location.city}
                    style={imgStyle(index)}
                  />
                </div>

                {/* Card Body */}
                <div
                  style={{
                    padding: "2rem",
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                  }}
                >
                  <small
                    style={{
                      color: "#5a6a82",
                      fontSize: "0.92rem",
                      lineHeight: 1.7,
                    }}
                  >
                    {location.description}
                  </small>
                </div>

                {/* Manager Footer */}
                {location.manager && (
                  <NavLink
                    to="/contact"
                    style={{ textDecoration: "none" }}
                  >
                    <div style={managerFooterStyle(index)}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            width: "42px",
                            height: "42px",
                            borderRadius: "10px",
                            background:
                              hoveredIndex === index ? "#002c6a" : "#eef3fb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1rem",
                            fontWeight: 700,
                            color:
                              hoveredIndex === index ? "#fff" : "#002c6a",
                            flexShrink: 0,
                            overflow: "hidden",
                            transition:
                              "background 0.3s ease, color 0.3s ease, transform 0.3s ease",
                            transform:
                              hoveredIndex === index
                                ? "scale(1.08)"
                                : "scale(1)",
                          }}
                        >
                          {location.manager.photo ? (
                            <img
                              src={location.manager.photo}
                              alt={location.manager.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            location.manager.name.charAt(0)
                          )}
                        </div>

                        <div>
                          <h6
                            style={{
                              margin: 0,
                              fontSize: "0.95rem",
                              fontWeight: 700,
                              color:
                                hoveredIndex === index ? "#002c6a" : "#1e293b",
                              transition: "color 0.3s ease",
                            }}
                          >
                            {location.manager.name}
                          </h6>
                          <span
                            style={{
                              display: "block",
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              color:
                                hoveredIndex === index ? "#1a5fb4" : "#94a3b8",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              marginTop: "2px",
                              transition: "color 0.3s ease",
                            }}
                          >
                            {location.manager.designation || "Manager"}
                          </span>
                        </div>
                      </div>

                      {/* Arrow */}
                      <i
                        className="fas fa-arrow-right"
                        style={arrowStyle(index)}
                      ></i>
                    </div>
                  </NavLink>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationsSection;